<template>
  <div :style="style" class="control-container" @click="demoOnly()">
    <div class="control-row title">
        <CktextComponent :rawHtml="control.data.data.title">    
        </CktextComponent>
        <div v-if="control.data.data.misc.required" class="required">*</div>
    </div>
    <div class="control-row">
        <CktextComponent :rawHtml="control.data.data.subtitle">    
        </CktextComponent>
    </div>
    <div class="control-row">
        <div class="chepai-container blue-b-white-char">
          <div class="chepai-inner-container">
            <div class="chepai-character">
              
            </div>
            <div class="chepai-character">
              
            </div>
            <div class="chepai-character">
              
            </div>
            <div class="chepai-character">
              
            </div>
            <div class="chepai-character">
              
            </div>
            <div class="chepai-character">
              
            </div>
            <div class="chepai-character">
              
            </div>
          </div>  
      </div>
    </div>   
  </div>
</template>

<script>
import CktextComponent from '../CkText.vue';

export default {
  name: 'ChepaiControl',
  components: {
    CktextComponent
  },
  data(){
    return {
      style:''
    }
  },
  props: {
    control: null
  },
  methods:{
    demoOnly(){

      this.$toast.add({severity:'error', summary: this.$common.TITLE, detail:this.i18n.t('message.form_unavailable_h5'), life: 3000});

    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.control-container:last-child{
      margin-bottom: 0px;
  }
  .control-row{
      margin-bottom: 10px;
      text-align:left;
  }

  .title{
      display: flex;
  }
  .required{
    color:#f7363f;
  }   
  .chepai-container{
            margin-top:10px;
            border-radius:8px;
            padding:5px;
            box-shadow:2px 2px 4px rgb(0 0 0 / 30%);
  }

  .chepai-inner-container{
                display: flex;
                justify-content: space-between;
                border-width: 3px;
                border-style: solid;
                border-radius:8px;
                padding:20px 10px;
  }
  .blue-b-white-char{
            background-color: #045de2;
            color:white;
  }

  .chepai-character{
                        height: 54px;
                        width: 12%;
                    }
</style>